import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdArrowLeft: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 25 12" fill="none" {...props}>
    <Path
      d="M5.88235 11.7754L6.99593 10.6618L3.01473 6.68045L25 6.68045L25 5.10553L3.01473 5.10553L6.99593 1.11362L5.88235 -8.34704e-06L5.14251e-07 5.89304L5.88235 11.7754Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdArrowLeft;
